<!-- Presentational "doctor joined" chat status card: blue-toned avatar with an online presence dot beside the caption/title. Data loading lives in the app views via useChatStaffJoin. -->

<script lang="ts" setup>
import Avatar from '../Avatar.vue';
import ChatStatusCard from './ChatStatusCard.vue';

// Props
defineProps<{
  /** Localised caption, e.g. "Doctor joined" — kept in the consumer so copy can stay per-app/role-aware. */
  caption: string;
  /** Full staff name; ignored while `loading`. */
  title: string;
  firstName?: string;
  lastName?: string;
  /** Explicit loading signal (e.g. `!vm.loaded`) — renders skeletons instead of inferring from empty data. */
  loading?: boolean;
}>();
</script>

<template>
  <ChatStatusCard
    tone="blue"
    :caption="caption"
    :title="title"
    :loading="loading"
  >
    <template #media>
      <div :class="css.avatar">
        <Avatar
          color="blue"
          :size="48"
          :first-name="firstName"
          :last-name="lastName"
          :loading="loading"
        />
        <span :class="css.presence" />
      </div>
    </template>
  </ChatStatusCard>
</template>

<style lang="scss" module="css">
.avatar {
  position: relative;
  width: 48px;
  height: 48px;
}

.presence {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: $color-green-500;
  border: 2px solid $color-white;
}
</style>
